import { Box, Modal } from "@mui/material";
import React, { useState } from "react";
import DeleteNote from "./DeleteNote";
import TypeNoteChip from "../Chips/TypeNoteChip";
import { useNavigate } from "react-router-dom";
import DateAndTimeChipMobile from "../Chips/DateAndTimeChipMobile";
import EditButtonMobile from "../Buttons/EditButtonMobile";
import DeleteButtoMobile from "../Buttons/DeleteButtoMobile";
import ViewButtonSmall from "../Buttons/ViewButtonSmall";
import EditHandoverNotesMobile from "./EditHandoverNotesMobile";

import ViewHandoverNotes from "./ViewHandoverNotes";

function HandoverNotesContainerGlobalMobile(props) {
  //VARIABLES

  const styleEdit = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "80%",
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const styleDeleteModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 300,
    height: 260,
    borderRadius: 2,
    bgcolor: "background.paper",
    /*border: "1px solid #000",*/
    boxShadow: 24,
    // p: 4,
  };

  //STATES
  const navigate = useNavigate();
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);

  const [shouldNavigate] = React.useState(false);

  //FUNCTIONS
  const openEditModal = () => {
    setShowEditModal(true);
  };
  const openDeleteModal = () => {
    setShowDeleteModal(true);
  };
  const openViewModal = () => {
    setShowViewModal(true);
  };

  const closeEditModal = () => {
    setShowEditModal(false);
  };
  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const closeViewModal = () => {
    setShowViewModal(false);
  };

  React.useEffect(() => {
    if (shouldNavigate) {
      navigate(`/client/${props.clientId}`, {
        state: props, // Passez l'objet client complet
      });
    }
  }, [shouldNavigate]);

  console.log("props.generalAnnoucement:", props.generalAnnouncement);

  return (
    <div className="notes-wrapper">
      <Modal
        open={showEditModal}
        onClose={closeEditModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleEdit}>
          <EditHandoverNotesMobile
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeEditModal}
            {...props}
          />
        </Box>
      </Modal>

      <Modal
        open={showDeleteModal}
        onClose={closeDeleteModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleDeleteModal}>
          <DeleteNote
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeDeleteModal}
          />
        </Box>
      </Modal>

      <Modal
        open={showViewModal}
        onClose={closeViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleEdit}>
          <ViewHandoverNotes
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeViewModal}
            {...props}
          />
        </Box>
      </Modal>
      <div className="note-container-mobile">
        <div className="note-container-block-1-mobile">
          <div style={{ marginRight: "5px" }}>
            <TypeNoteChip noteType={props.noteType} />
          </div>
          <DateAndTimeChipMobile date={props.noteDate} />
          <DateAndTimeChipMobile date={props.noteTime} />
        </div>

        <div className="note-container-block-3-mobile">
          <div className="note-container-line-1-mobile">
            <div
              className="note-container-line1-block1bis-mobile left-block"
              style={{ width: "60%" }}
            >
              <div className="title-cell-container-mobile">
                <span className="title-text">Done by:</span>
                <span className="content-text">{props.doneBy}</span>
              </div>
            </div>

            <div
              className="note-container-line1-block2-mobile centre-block2"
              style={{ width: "40%" }}
            >
              <div className="sub-block-2">
                <EditButtonMobile handleOpen={openEditModal} />
                <ViewButtonSmall handleOpen={openViewModal} />
                <DeleteButtoMobile handleOpen={openDeleteModal} />
              </div>
            </div>
          </div>
          <div
            className="note-container-line-2bis-mobile"
            style={{ whiteSpace: "pre-wrap" }}
          >
            <div className="title-cell-container">
              General Announcement / Discussion
            </div>
            {props.generalAnnouncement}
          </div>
        </div>
      </div>
    </div>
  );
}

export default HandoverNotesContainerGlobalMobile;
